<template>
    <div class="w-full surface-100 pb-6 pt-6">
		<div class="center px-2 xl:pl-4 xl:pr-4">
			<div class="hidden xl:block p-2 text-800 font-semibold mb-5 align-items-center text-center
                text-3xl xl:text-6xl lg:text-6xl md:text-5xl sm:text-5xl">
				{{ content[lang_].title }} <span class="text-lg">**</span>
			</div>
            <div class="block xl:hidden p-2 text-800 font-semibold mb-3 align-items-center text-center
                text-5xl xl:text-6xl lg:text-6xl md:text-5xl sm:text-5xl">
				{{ content[lang_].title_short }}
			</div>
			<div class="w-full flex flex-column">

                <Carousel v-if="reviews" :value="reviews" :numVisible="3" :numScroll="3" :showNavigators="false" :responsiveOptions="responsiveOptions"
                    class="mainReviewsSlider 
                        py-2 xl:py-0 lg:py-0 md:py-0 sm:py-0 
                        border-round-xl">
                    <template #item="slotProps">
                        <div  class="flex flex-column relative surface-0
                            p-3 mb-2 xl:mb-3 mx-2
                            border-round-xl xl:border-round-2xl
                            border-ios-xl xl:border-ios-3xl lg:border-ios-2xl">

                            <Review :review="slotProps.data" :bank_list="bank_list" :payment_systems="payment_systems" />

                            </div>
                    </template>
                </Carousel>

                <Carousel v-else :value="skeletons" :numVisible="3" :numScroll="3" :showNavigators="false" :responsiveOptions="responsiveOptions">
                    <template #item="slotProps">
                        <div  class="flex flex-column relative surface-0
                            p-3 mb-2 xl:mb-3 mx-2
                            border-round-xl xl:border-round-2xl
                            border-ios-xl xl:border-ios-3xl lg:border-ios-2xl">
                            <div class="flex flex-row mb-2">
                                <Skeleton width="100%" height="25px" class="flex text-xl xl:text-2xl font-semibold text-800 ml-3 pt-1 pb-1 xl:pt-2 xl:pb-2" />
                            </div>
                            <div class="flex flex-row mb-2">
                                <Skeleton width="100%" height="25px" class="flex text-xl xl:text-2xl font-semibold text-800 ml-3 pt-1 pb-1 xl:pt-2 xl:pb-2" />
                            </div>
                            <div class="flex flex-row">
                                <Skeleton width="100%" height="100px" class="flex flex-1 flex-column text-md text-800 surface-300 p-2 xl:p-3 line-height-2 ml-3 border-round-top-xl border-round-right-xl"/>
                            </div>
                        </div>
                    </template>
                </Carousel>

                <div class="w-full flex p-2 justify-content-center mb-3 align-items-center text-center">
                    <span class="text-sm text-500">
                        {{ content[lang_].text }}
                    </span>
                </div>

                <div class="w-full flex justify-content-center">
                    <Button :label="content[lang_].button" class="flex px-5 surface-0 border-round-lg" variant="text" severity="info" @click="go_reviews()" />
                </div>  

			</div>
		</div>
	</div>	
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Review from '@/components/widgets/Review.vue'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    data(){
        return {
            reviews: null,
            loading: false,
            bank_list: [],
            payment_systems: [],
			content: {
				ru: {
					title: 'Честные отзывы',
					title_short: 'Отзывы',
                    text: '** Отзыв можно оставить сразу после выполнения перевода. Все отзывы оставленные на сайте – реальные отзывы наших клиентов.',
					button: 'Все отзывы',
				},
				en: {
					title: 'Honest reviews',
					title_short: 'Reviews',
                    text: '** You can leave a review immediately after completing the transfer. All reviews posted on the site are real reviews of our customers.',
					button: 'All reviews',
				},
			},
            skeletons: [
                {
                    comment: '',
                },
                {
                    comment: '',
                },
                {
                    comment: '',
                },
            ],
            responsiveOptions: [
                {
                    breakpoint: '992px',
                    numVisible: 2,
                    numScroll: 1
                },
                {
                    breakpoint: '575px',
                    numVisible: 1,
                    numScroll: 1
                }
            ]
        }
    },
    components: {
        Review
    },
	computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },  
    },
	methods: {
		get_format_amount(amount, currency){
            return this.helper.format_amount(amount, currency)
        },
        go_reviews(){
            this.$router.push({
                path: '/reviews/'
            })
        },
        get_bank_image(code){
            return this.helper.get_bank_image(code, this.$store.state.payment.banks)
        },
        async GetReviews(){
            this.loading = true
            try {
                this.reviews = []
                const reviews = await this.connect.get_reviews({limit: 6, skip: 0, sort: 'good', filter: {}}).then(res=>res)
                if(reviews.result && reviews.data) this.reviews = reviews.data
            } catch {}
            this.loading = false
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        }
	},
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.GetReviews().then()
        this.LoadBankList().then()
        this.LoadPaymentSystems().then()
    }
}
</script>
